import { getExpectedDayType } from './program-type.utils';
/** Latest weight (kg) logged on or before the last day in `weekDateStrings`. */
export function latestWeightKgInWeek(measurements, weekDateStrings) {
    let last = null;
    for (const dateStr of weekDateStrings) {
        const weight = measurements[dateStr]?.weight;
        if (typeof weight === 'number' && weight > 0) {
            last = weight;
        }
    }
    return last;
}
/**
 * Net weight change for the viewed week vs the prior week (kg).
 * Uses the latest weight in each week when multiple weigh-ins exist.
 */
export function computeWeeklyWeightLossKg(measurements, currentWeekDates, previousWeekDates) {
    const current = latestWeightKgInWeek(measurements, currentWeekDates);
    const previous = latestWeightKgInWeek(measurements, previousWeekDates);
    if (current == null || previous == null) {
        return null;
    }
    return current - previous;
}
/** Spreadsheet-style weekly WL label, e.g. "-0.2" or "+0.3". */
export function formatWeeklyWeightLossLbs(deltaKg) {
    const lbs = deltaKg * 2.20462;
    const rounded = Math.round(lbs * 10) / 10;
    if (rounded === 0) {
        return '0';
    }
    return rounded > 0 ? `+${rounded.toFixed(1)}` : rounded.toFixed(1);
}
export function dayTypeLabelsForWeekStart(programType, weekStartDate, weekStartsOn = 1) {
    const labels = [];
    for (let i = 0; i < 7; i++) {
        const date = new Date(weekStartDate);
        date.setDate(weekStartDate.getDate() + i);
        labels.push(getExpectedDayType(programType, date, weekStartsOn));
    }
    return labels;
}
/** Karen meal-map row label for Tue–Sun cells in the Weekly WL row. */
export function weeklyWlDayTypeLabel(dayType) {
    switch (dayType) {
        case 'loss':
            return 'Weight Loss';
        case 'maintenance':
            return 'Maintenance';
        case 'reward':
            return 'Reward';
        default:
            return dayType;
    }
}
